// Analytics must not turn a successful app action into an error. Handle both
// immediate exceptions and rejected promises without hiding unrelated app errors.
export function runOptionalAnalytics(run, fallback, onFailure) {
  const failed = error => {
    // Swallowing a failure must not also hide it: without a trace, a silent
    // fallback looks identical to analytics working correctly.
    console.error("[Analytics] operation failed:", error);
    if (onFailure) {
      try {
        const result = onFailure();
        if (result && typeof result.then === "function") Promise.resolve(result).catch(() => {});
      } catch (cleanupError) {
        // Failure cleanup is also best effort.
      }
    }
    return fallback;
  };
  try {
    const result = run();
    if (result && typeof result.then === "function") {
      return Promise.resolve(result).catch(failed);
    }
    return result;
  } catch (error) {
    return failed(error);
  }
}
